import { lazy } from "@bridgesplit/ui";

const LoopDetail = lazy(() => import("./LoopDetail"));
export { LoopDetail };
export * from "./wind";
export * from "./positions";
